export const infrastructure = [
    {
        icon:"bus",
        key: "verticalSignalization",
        description: "Vertikalna signalizacija"
    },
    {
        icon:"road",
        key: "horizontalSignalization",
        description: "Horizontalna signalizacija"
    },
    {
        icon:null,
        key: "platforms",
        description: "Natkriveni peroni"
    },
    {
        icon:"chair",
        key: "platformSeating",
        description: "Klupe na peronu"
    },
    {
        icon:"trash-alt",
        key: "trashCan",
        description: "Koš za odlaganje otpada"
    },
    {
        icon:"cash-register",
        key: "ticketOffice",
        description: "Blagajna"
    },
    {
        icon:"calendar-alt",
        key: "timetableExcerpt",
        description: "Izvod iz voznog reda"
    },
    {
        icon:"money-check",
        key: "tariffExcerpt",
        description: "Izvod iz tarifne ponude"
    },
    {
        icon:"location-arrow",
        key: "ptMapsScheme",
        description: "Grafički prikaz mreže linija"
    },
    {
        icon:"info-circle",
        key: "touristInfo",
        description: "Info za turiste"
    },
    {
        icon:"ticket-alt",
        key: "ticketMachine",
        description: "Automat za karte"
    },
    {
        icon:"volume-up",
        key: "loudspeaker",
        description: "Zvučnik za najavu"
    },
    {
        icon:"video",
        key: "videoSurveillance",
        description: "Video nadzor"
    },
    {
        icon:"shield-alt",
        key: "securityService",
        description: "Zaštitarska služba"
    },
    {
        icon:"phone-volume",
        key: "emergencyCall",
        description: "Poziv u slučaju opasnosti"
    },
    {
        icon:"lightbulb",
        key: "lightLamps",
        description: "Rasvjeta"
    },
    {
        icon:"store",
        key: "kiosk",
        description: "Kiosk"
    },
    {
        icon:"restroom",
        key: "waitingRoom",
        description: "Čekaonica"
    },
    {
        icon:"chair",
        key: "waitingRoomSeating",
        description: "Klupe u čekaonici"
    },
    {
        icon:"toilet",
        key: "toilets",
        description: "Sanitarni čvor"
    },
    {
        icon:"baby",
        key: "changingRoomsBaby",
        description: "Prostorija za prematanje djece"
    },
    {
        icon:null,
        key: "escalators",
        description: "Pokretne stube"
    },
    {
        icon:"sort",
        key: "elevators",
        description: "Lift"
    },
    {
        icon:"wheelchair",
        key: "ramps",
        description: "Pristupna rampa za osobe s invaliditetom"
    },
    {
        icon:"parking",
        key: "carParking",
        description: "Parking za automobile"
    },
    {
        icon:"parking",
        key: "bicycleParking",
        description: "Parking za bicikle"
    },
    {
        icon:"walking",
        key: "walkwayPathConnectivity",
        description: "Povezanost pješačkom stazom"
    },
    {
        icon:"bicycle",
        key: "bicyclePathConnectivity",
        description: "Povezanost biciklističkom stazom"
    },
    {
        icon:null,
        key: "busTurnout",
        description: "Ugibalište"
    },
    {
        icon:null,
        key: "shelter",
        description: "Nadstrešnica"
    },
    {
        icon:null,
        key: "nameTag",
        description: "Oznaka naziva stajališta"
    },
    {
        icon:"route",
        key: "busLineConnectivity",
        description: "Povezanost autobusnim linijama"
    },
]